"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createGeneratedLoanTapeToGeneratedCovenantLoanTapeDependencies = exports.attachCovenantLoanTapeArtifactToMasterLoanTape = void 0;
const lodash_1 = __importDefault(require("lodash"));
const common_1 = require("@finley-technologies/common");
const utils = __importStar(require("./utils"));
const { cloneDeep } = lodash_1.default;
/**
 * Revises dependencies between generatedCovenantLoanTape and input
 * generatedLoanTape artifact.
 *
 *                        *** Current ***
 * +---------------------+      +---------------------------+
 * | generatedLoanTape   | ---> | generatedCovenantLoanTape |
 * +---------------------+      +---------------------------+
 *
 *                        *** Revised ***
 * +---------------------+      +------------------+      +---------------------------+
 * | generatedLoanTape   | ---> |  masterLoanTape  | ---> | generatedCovenantLoanTape |
 * +---------------------+      +------------------+      +---------------------------+
 *
 * masterLoanTape is needed to ensure access to all receivables
 *
 * output of generatedCovenantLoanTape is optionally borrowingBaseReport, which
 * is not affected by synthetic actions
 */
const attachCovenantLoanTapeArtifactToMasterLoanTape = ({ dbGraph, loanTapeTypeMap, }) => {
    // find instances of generatedCovenantLoanTape to use as the basis of this
    // synthetic mutation, otherwise return early since there is nothing to update
    const covenantLoanTapesInGraph = utils.filterGeneratedCovenantLoanTapes({
        dataTapes: dbGraph.dataTapes,
    });
    if (covenantLoanTapesInGraph.length === 0) {
        return dbGraph;
    }
    const clonedDbGraph = cloneDeep(dbGraph);
    const { dataTapes } = clonedDbGraph;
    let { dataTapeDependencies } = clonedDbGraph;
    for (const covenantLoanTape of covenantLoanTapesInGraph) {
        const { creditFacilitySlug, loanProductSlug } = covenantLoanTape;
        (0, common_1.finleyAssert)(loanProductSlug, 'loanProductSlug must exist on generatedCovenantLoanTape');
        const loanTapeType = loanTapeTypeMap[loanProductSlug];
        const masterLoanTapes = utils.filterMasterLoanTapes({ dataTapes });
        let masterLoanTapeFilter;
        switch (loanTapeType) {
            case 'masterLoanTape':
            case 'preassignedMasterLoanTape':
                // guaranteed to have only 1 generatedLoanTape per loanProductSlug
                masterLoanTapeFilter = (loanTape) => loanTape.loanProductSlug === loanProductSlug;
                break;
            case 'preassignedLoanTape':
                // may have multiple generatedLoanTapes per loanProductSlug, so we must also filter by creditFacilitySlug
                (0, common_1.finleyAssert)(creditFacilitySlug, 'creditFacilitySlug must exist on generatedCovenantLoanTape with [loanTapeType:preassignedLoanTape]');
                masterLoanTapeFilter = (loanTape) => loanTape.creditFacilitySlug === creditFacilitySlug &&
                    loanTape.loanProductSlug === loanProductSlug;
                break;
            default:
                return (0, common_1.finleyAssertUnreachable)(loanTapeType);
        }
        const filteredMasterLoanTapes = masterLoanTapes.filter(masterLoanTapeFilter);
        (0, common_1.finleyAssert)(filteredMasterLoanTapes.length === 1, `unable to find single masterLoanTape with [creditFaciltySlug:${creditFacilitySlug}] and [loanProductSlug:${loanProductSlug}, found: ${filteredMasterLoanTapes.length}`);
        const masterLoanTape = filteredMasterLoanTapes[0];
        const covenantLoanTapeDependencies = utils.getDependenciesByOutputId({
            dataTapeDependencies,
            outputArtifactId: covenantLoanTape.id,
        });
        (0, common_1.finleyAssert)(covenantLoanTapeDependencies.length === 1, `covenantLoanTape should have 1 dependency, found ${covenantLoanTapeDependencies.length}`);
        const covenantLoanTapeDependency = covenantLoanTapeDependencies[0];
        // remove edge generatedLoanTape <> covenantLoanTape
        dataTapeDependencies = utils.removeDependency({
            dataTapeDependencies,
            dependencyToRemove: covenantLoanTapeDependency,
        });
        // add masterLoanTape <> covenantLoanTape edge
        dataTapeDependencies.push({
            inputArtifactId: masterLoanTape.id,
            outputArtifactId: covenantLoanTape.id,
        });
    }
    return {
        dataTapes,
        dataTapeDependencies,
    };
};
exports.attachCovenantLoanTapeArtifactToMasterLoanTape = attachCovenantLoanTapeArtifactToMasterLoanTape;
/**
 * partial logical inverse of {@link attachCovenantLoanTapeArtifactToMasterLoanTape}
 *
 * {@link detachSyntheticRecords} already removes the generatedLoanTape ->
 * masterLoanTape and masterLoanTape -> generatedCovenantLoanTape dependencies,
 * so the only remaining action is to create the generatedLoanTape ->
 * generatedCovenantLoanTape dependency
 *
 *                        *** Current ***
 * +---------------------+      +------------------+      +---------------------------+
 * | generatedLoanTape   | ---> |  masterLoanTape  | ---> | generatedCovenantLoanTape |
 * +---------------------+      +------------------+      +---------------------------+
 *
 *                        *** Revised ***
 * +---------------------+      +---------------------------+
 * | generatedLoanTape   | ---> | generatedCovenantLoanTape |
 * +---------------------+      +---------------------------+
 *
 * output of generatedCovenantLoanTape is optionally borrowingBaseReport, which
 * is not affected by synthetic actions
 */
const createGeneratedLoanTapeToGeneratedCovenantLoanTapeDependencies = ({ generatedCovenantLoanTapes, generatedLoanTapes, loanTapeTypeMap, }) => generatedCovenantLoanTapes.map((covenantLoanTape) => {
    const { creditFacilitySlug, loanProductSlug } = covenantLoanTape;
    (0, common_1.finleyAssert)(loanProductSlug, 'loanProductSlug must exist on generatedCovenantLoanTape');
    const loanTapeType = loanTapeTypeMap[loanProductSlug];
    let generatedLoanTapeFilter;
    switch (loanTapeType) {
        case 'masterLoanTape':
        case 'preassignedMasterLoanTape':
            generatedLoanTapeFilter = (loanTape) => loanTape.loanProductSlug === loanProductSlug;
            break;
        case 'preassignedLoanTape':
            (0, common_1.finleyAssert)(creditFacilitySlug, 'creditFacilitySlug must exist on generatedCovenantLoanTape for [loanTapeType:preassignedLoanTape]');
            generatedLoanTapeFilter = (loanTape) => loanTape.creditFacilitySlug === creditFacilitySlug &&
                loanTape.loanProductSlug === loanProductSlug;
            break;
        default:
            return (0, common_1.finleyAssertUnreachable)(loanTapeType);
    }
    const filteredGeneratedLoanTapes = generatedLoanTapes.filter(generatedLoanTapeFilter);
    (0, common_1.finleyAssert)(filteredGeneratedLoanTapes.length === 1, `unable to find single generatedLoanTape with [creditFaciltySlug:${creditFacilitySlug}] and [loanProductSlug:${loanProductSlug}], found: ${filteredGeneratedLoanTapes.length}`);
    const generatedLoanTape = filteredGeneratedLoanTapes[0];
    return {
        inputArtifactId: generatedLoanTape.id,
        outputArtifactId: covenantLoanTape.id,
    };
});
exports.createGeneratedLoanTapeToGeneratedCovenantLoanTapeDependencies = createGeneratedLoanTapeToGeneratedCovenantLoanTapeDependencies;
//# sourceMappingURL=covenantLoanTape.js.map